import { Component, ViewChild, ViewContainerRef, Type } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatTreeModule} from '@angular/material/tree';
import {MatToolbarModule} from '@angular/material/toolbar';
import {Check, Apiv1Service} from '../../services/apiv1.service';
import {LoginService} from '../../services/login.service';
import {UserComponent} from '../masks/auth/user/user.component';
import {GroupComponent} from '../masks/auth/group/group.component';
import {RoleComponent} from '../masks/auth/role/role.component';
import {RightComponent} from '../masks/auth/right/right.component';
import {UsergroupComponent} from '../masks/auth/usergroup/usergroup.component';
import {GrouproleComponent} from '../masks/auth/grouprole/grouprole.component';
import {RolerightComponent} from '../masks/auth/roleright/roleright.component';

import {LoginComponent} from '../login/login.component';

import {TracksComponent} from '../masks/gps/tracks/tracks.component';
import {TrackComponent} from '../masks/gps/track/track.component';



/**
 * Food data with nested structure.
 * Each node has a name and an optional list of children.
 */


interface MenuNode {
  name: string;
  check?: Check;
  click?: string;
  children?: MenuNode[];
}

@Component({
  selector: 'app-home',
  imports: [MatSidenavModule, MatButtonModule, MatIconModule, MatTreeModule, MatToolbarModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef ;

constructor(private store: Apiv1Service, private route: ActivatedRoute, private router: Router, private loginService: LoginService) {}


  // Optionally keep track of the current componentRef to destroy it or reuse
  private componentRef: any;

  async loadComponent(type: ComponentKey) { // 👈 enforce the correct key type
    this.container.clear();

    const comp = type === 'race' ? (await import('../races/races.component')).RacesComponent : COMPONENT_MAP[type]; // ✅ no more TS error
    this.componentRef = this.container.createComponent(comp);

    // optional: pass inputs
    //this.componentRef.instance.text = `Loaded ${type}`;
  }
showFiller = false;
dataSource: MenuNode[] = [];

  userId: string = "";
  userName: string = "";

async ngOnInit() {
  console.log("HomeComponent::ngOnInit(): " + "Start");

    const mask = this.route.snapshot.data['mask'];
console.log("HomeComponent::ngOnInit(): " + "Var [mask]: ["+mask+"].");


    if (this.loginService.isLoggedIn())
    {
  console.log("HomeComponent::ngOnInit(): " + "Is logged in");
      this.dataSource = await this.filterByPermission(EXAMPLE_DATA);

      this.loadComponent(mask);
    }
    else
    {
console.log("HomeComponent::ngOnInit(): " + "Is not logged in");
        this.loadComponent('login');
    }

    
  }

logout(){
this.loginService.logout();

}

goToPath( path: string) {
    console.log("HomeComponent::goToPath(): " + "path:" + path);
this.router.navigate([path]); // Angular route path
  }
//dataSource = EXAMPLE_DATA;

  childrenAccessor = (node: MenuNode) => node.children ?? [];

  hasChild = (_: number, node: MenuNode) => !!node.children && node.children.length > 0;
private async filterByPermission(nodes: MenuNode[]): Promise<MenuNode[]> {
    const result: MenuNode[] = [];


    for (const node of nodes) {
      // if node has a check, verify it
      let allowed = true;
      if (node.check) {
        if (this.userId.length == 0){
          var u = await this.store.getUserId();
          [this.userId, this.userName] = u.split(":");

        }
        if (node.check.path.includes("{user_id}") ) {

          node.check.path = node.check.path.replace("{user_id}", this.userId);
        }
        allowed = await this.store.checkPermissionForPathAndActionOnCheck(node.check);
      }

      if (!allowed) continue; // skip node if not allowed

      const filteredNode: MenuNode = { ...node };

      if (node.children) {
        filteredNode.children = await this.filterByPermission(node.children);
      }

      result.push(filteredNode);
    }

    return result;
  }
}
const EXAMPLE_DATA: MenuNode[] = [
  {
    name: 'Auth',
    check: { path: '/auth', action: 'GET' },
    children: [
      {name: 'Users',
        click: 'auth/user'
      }, 
      {name: 'Groups',
        click: 'auth/group'}, 
      {name: 'Roles',
        click: 'auth/role'},
      {name: 'Rights',
        click: 'auth/right'},
      {name: 'UserGroups',
        click: 'auth/usergroup'},
      {name: 'GroupRoles',
        click: 'auth/grouprole'},
      {name: 'RoleRights',
        click: 'auth/roleright'}
    ],
  },
  {
    name: 'Tracks',
    check: { path: '/gps_track', action: 'GET' },
    click: 'track',
  },
  {
    name: 'Races',
    check: { path: '/races', action: 'GET' },
    click: 'race',

  }
];

type ComponentKey = 'login'|'user' | 'group' | 'role' | 'right' | 'usergroup' | 'grouprole'| 'roleright' | 'track' | 'track_one' | 'race';
const COMPONENT_MAP: Record<Exclude<ComponentKey, 'race'>, Type<any>> = {
  user: UserComponent,
  group: GroupComponent,
  role: RoleComponent,
  right: RightComponent,
  usergroup: UsergroupComponent,
  grouprole: GrouproleComponent,
  roleright: RolerightComponent,
  login: LoginComponent,
  track: TracksComponent,
  track_one: TrackComponent,
  // ... add more
};